export default __webpack_public_path__ + "static/media/add_business.95283801.svg";